
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Status = () => {
  return (
    <SettingsMetaData propertyName={"Status_Appoinments"} viewPropertyName={"Status"} />
  );
};
export default Status;
